import { render, staticRenderFns } from "./AddActivitiesModal.vue?vue&type=template&id=a5b4c6e0&scoped=true"
import script from "./AddActivitiesModal.vue?vue&type=script&lang=js"
export * from "./AddActivitiesModal.vue?vue&type=script&lang=js"
import style0 from "./AddActivitiesModal.vue?vue&type=style&index=0&id=a5b4c6e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b4c6e0",
  null
  
)

export default component.exports